module.exports = __webpack_public_path__ + "static/media/wf.16bc74ea.svg";